export default __webpack_public_path__ + "static/apples-f6dbf88094c4f89075674034e724420d.jpg";